module.exports = __webpack_public_path__ + "static/media/model-xtrail-t30.0740a6d9.webp";